
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/income-tax-efiling-2",
      function () {
        return require("private-next-pages/cleartax.in/income-tax-efiling-2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/income-tax-efiling-2"])
      });
    }
  